import RestService from "./restService";
import { TASK } from "../../url/index";

const singleton = Symbol();
const singletonEnforcer = Symbol();

class TaskService extends RestService {
  constructor(enforcer) {
    super(TASK.TASK);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Task RestService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new TaskService(singletonEnforcer);
    }
    return this[singleton];
  }

  saveCategory(payload) {
    return this._api_connector.post(TASK.CATEGORY.url, payload);
  }

  updateCategory(payload) {
    return this._api_connector.put(TASK.CATEGORY.uri(payload.id).url, payload);
  }

  removeCategory(id) {
    return this._api_connector.delete(TASK.CATEGORY.uri(id).url);
  }

  saveConversation(payload) {
    return this._api_connector.post(TASK.CONVERSATION.url, payload);
  }

  updateConversation(payload) {
    return this._api_connector.put(TASK.CONVERSATION.uri(payload.id).url, payload);
  }

  removeConversation(id) {
    return this._api_connector.delete(TASK.CONVERSATION.uri(id).url);
  }
}

export default TaskService;
